import { render, staticRenderFns } from "./payment-mango.vue?vue&type=template&id=305c51c0&scoped=true"
import script from "./payment-mango.vue?vue&type=script&lang=js"
export * from "./payment-mango.vue?vue&type=script&lang=js"
import style0 from "./payment-mango.vue?vue&type=style&index=0&id=305c51c0&prod&scoped=true&lang=css"
import style1 from "./payment-mango.vue?vue&type=style&index=1&id=305c51c0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305c51c0",
  null
  
)

export default component.exports